var exports = {
  "t": "fallbackToggle__fOP5QZ",
};

module.exports = exports;
